export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5344.740b299a.jpg";